import styled from "@yb/styled-px2rem";
import imgIcon from "@PUBLIC/M/images/ico/ico_load.png";

const Wrap = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 102;
	background-color: rgba(255, 255, 255, 0.5);
	min-height: 300px;
`;

const Box = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 101;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	transform: translate(-50%, -50%);

	> div {
		position: relative;
		width: 90px;
		height: 90px;
	}
`;

const Icon = styled.span<{icon?: string}>`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 90px;
	height: 90px;
	animation: 1.5s fade infinite;
	&:nth-child(1) {
		animation-delay: 1s;
	}
	&:nth-child(2) {
		animation-delay: 2s;
	}
	&:nth-child(3) {
		animation-delay: 3s;
	}
	&:nth-child(4) {
		animation-delay: 4s;
	}
	&:nth-child(5) {
		animation-delay: 5s;
	}
	&:nth-child(6) {
		animation-delay: 6s;
	}
	&:before {
		display: block;
		width: 90px;
		height: 90px;
		background: url(${imgIcon}) no-repeat 0 0 / auto 90px;
		animation: 2s img infinite steps(6);
		content: "";
		opacity: 1;
	}

	@keyframes img {
		to {
			background-position: -540px 0;
		}
	}

	@keyframes fade {
		50% {
			opacity: 0.5;
			transform: translateY(10%);
		}
	}
`;

const Dot = styled.span`
	position: absolute;
	display: block;
	width: 3px;
	height: 20px;
	border-radius: 2px;
	background-color: #fed20b;
	overflow: hidden;
	opacity: 1;
	animation: 1.2s down infinite;
	&:nth-child(2) {
		bottom: 20px;
		left: -5px;
		animation-delay: 0.2s;
	}
	&:nth-child(3) {
		bottom: 25px;
		left: 5px;
		animation-delay: 0.4s;
	}
	&:nth-child(4) {
		bottom: 25px;
		right: 5px;
		animation-delay: 0.6s;
	}
	&:nth-child(5) {
		bottom: 20px;
		right: -5px;
		animation-delay: 0.8s;
	}

	@keyframes down {
		20% {
			height: 4px;
		}
		50% {
			opacity: 0.5;
			height: 0;
		}
	}
`;

const IcoMove = () => (
	<Wrap>
		<Box>
			<div>
				<Icon />
				<Dot />
				<Dot />
				<Dot />
				<Dot />
			</div>
		</Box>
	</Wrap>
);

export default IcoMove;
